import selectors from '../globals/selectors';
import accordion from './accordion';

export default () => {
	const accordions = document.querySelectorAll(selectors.accordion.element);
	accordions.forEach((el) => accordion(el));
};
